import WorkItemNotesLoading from '~/work_items/components/notes/work_item_notes_loading.vue';
export default {
    name: 'WorkItemLoading',
    loader: {
        attributesRepeat: 6
    },
    components: {
        WorkItemNotesLoading
    }
};
